import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-value',
  imports: [CommonModule],
  templateUrl: './value.component.html',
})
export default class ValueComponent {}
